import React from 'react'
import ReactDOM from 'react-dom'
import AppContainer from 'containers/AppContainer'
import * as serviceWorker from 'serviceWorker'
import { createBrowserHistory } from 'history'
import { stopReportingRuntimeErrors } from 'react-error-overlay'
import './index.scss'
if (process.env.NODE_ENV === 'development') {
  stopReportingRuntimeErrors() 
}

const history = createBrowserHistory()

ReactDOM.render(
 <React.StrictMode>
    <AppContainer history={history} />,
   </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
